export default __webpack_public_path__ + "static/media/23.798ebdfa.webp";